import React from 'react';
import { PROFILE_STATUS_OPTIONS } from '../../../config/enum-options.js';

const LANGUAGE_OPTIONS = [
  { value: 'en', label: 'English' },
  { value: 'ru', label: 'Russian' },
  { value: 'ar', label: 'Arabic' },
];

function selectedOptions(event) {
  return Array.from(event.target.selectedOptions).map((option) => option.value);
}

export function MarketingEmailMultiSelect({ name, label, value = [], options = [], onChange, disabled }) {
  return (
    <div className="col-md-4">
      <label className="form-label">{label}</label>
      <select
        name={name}
        multiple
        className="form-select"
        value={Array.isArray(value) ? value : []}
        onChange={(event) => onChange(name, selectedOptions(event))}
        disabled={disabled}
        size={5}
      >
        {options.map((option) => (
          <option key={option.value} value={option.value}>{option.label}</option>
        ))}
      </select>
    </div>
  );
}

export const MARKETING_EMAIL_PROFILE_STATUS_OPTIONS = PROFILE_STATUS_OPTIONS
  .map((status) => ({ value: status, label: status }));

export const MARKETING_EMAIL_LANGUAGE_OPTIONS = LANGUAGE_OPTIONS;
